import { requestApi } from './Api';

export const createComment = (navigate, params) =>
  requestApi({
    url: '/api/practice/comment/create',
    params,
    navigate
  });

export const updateComment = (navigate, params) =>
  requestApi({
    url: '/api/practice/comment/update',
    params,
    navigate
  });

export const deleteComment = (navigate, params) =>
  requestApi({
    url: '/api/practice/comment/delete',
    params,
    navigate
  });

export const getReplies = async (navigate, params) =>
  requestApi({
    url: '/api/practice/comment/get_replies',
    params,
    navigate
  });
